import React, { useEffect, useRef, useState } from "react";
import {
  Grid,
  TablePagination,
  Box,
  Typography,
  Divider,
  IconButton,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import "./table.scss";
import * as acts from "../../redux/investigation/actions";
import DashboardTableSkaleton from "../Skeletons/DashboardTableSkaleton";
import CustomizedSnackbars from "../Snackbars/CustomizedSnackbars";
import InfoIcon from "@mui/icons-material/InfoOutlined";
import styled from "styled-components";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import Label from "../Label/Label";
import { useLocation, useNavigate } from "react-router-dom";
import CAMSubHeader from "../Header/CAMSubHeader";
import constantValues from "../../constants/constantValues";
import { action } from "../../constants/action";
import { FileNameDialog } from "./FIleNameDialog";
import InvestigationFilterNewForDBSearch from "../InvestigationFilter/InvestigationSearchFIlterNewForDBSearch";

const {
  PRODUCT_NAME,
  TEMPLATE_NAME,
  BATCH_NAME,
  PARAMETER_NAME,
  VALUE,
  PDF_NAME,
  OUT_OF_RANGE,
  PAGE_NO,
} = constantValues;

const InvestigationTable = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  console.log(location.state);
  const investigationSearchApiStatus = useSelector(
    (state) => state?.investigation?.investigationSearchApiStatus
  );
  const exportInvestigationDataStatus = useSelector(
    (state) => state?.investigation?.exportInvestigationDataStatus
  );
  const tableData = useSelector((state) => state?.investigation?.tableData);
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [message, setMessage] = useState("");
  const [err, setErr] = useState(false);
  const [showUrlSnackbar, setShowUrlSnackbar] = useState(false);
  const [openFileNamePopup, setOpenFileNamePopup] = useState(false);
  const [filltersData, setFilltersData] = useState({});
  const hasMounted = useRef(false);

  useEffect(() => {
    if (hasMounted.current) {
      if (location.state?.projectId === undefined) {
        dispatch(
          acts.getInvestigationTableData({
            page: page + 1,
            page_size: rowsPerPage,
            filtersData: filltersData,
          })
        );
      }
    } else {
      hasMounted.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowsPerPage]);

  useEffect(() => {
    if (
      investigationSearchApiStatus?.apiError === true &&
      investigationSearchApiStatus?.next === false
    ) {
      setMessage(investigationSearchApiStatus?.message);
      setErr(true);
    }
  }, [investigationSearchApiStatus]);

  React.useEffect(() => {
    if (
      exportInvestigationDataStatus &&
      exportInvestigationDataStatus !== undefined
    ) {
      if (exportInvestigationDataStatus?.apiError === true) {
        setMessage(exportInvestigationDataStatus?.message);
        setErr(true);
        dispatch(acts.exportInvestigationDataAPiStatusClear());
      } else if (exportInvestigationDataStatus?.apiSuccess === true) {
        setShowUrlSnackbar(true);

        setMessage(exportInvestigationDataStatus?.data?.message);
        if (exportInvestigationDataStatus?.data?.data) {
          window.open(exportInvestigationDataStatus?.data?.data, "_blank");
        }
        dispatch(acts.exportInvestigationDataAPiStatusClear());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [exportInvestigationDataStatus]);

  const onExportCLick = () => {
    setOpenFileNamePopup(true);
  };
  const exportData = (fileName) => {
    setOpenFileNamePopup(false);
    dispatch(
      acts.exportInvestigationData(fileName, filltersData, tableData.data)
    );
  };

  const handlePageChange = (event, value) => {
    setPage(value);
    dispatch(
      acts.getInvestigationTableData({
        page_size: rowsPerPage,
        page: value + 1,
        filtersData: filltersData,
      })
    );
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
    setPage(0);
  };

  const getFilteredData = (filtersData, clickType) => {
    dispatch(
      acts.getInvestigationTableData({
        page_size: clickType === "searchClick" ? 100 : rowsPerPage,
        page: clickType === "searchClick" ? 0 + 1 : page + 1,
        filtersData: filtersData,
      })
    );

    if (clickType === "searchClick") {
      setPage(0);
      setRowsPerPage(100);
    }

    setFilltersData(filtersData);
  };

  const InfoTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#e8e7e7",
    },
  }));

  const handleCloseurlSnackbar = () => {
    setShowUrlSnackbar(false);
    setMessage("");
    dispatch(acts.exportInvestigationDataAPiStatusClear());
  };

  const onCLoseDialog = () => {
    setOpenFileNamePopup(false);
  };

  const CustomWidthTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))({
    [`& .${tooltipClasses.tooltip}`]: {
      maxWidth: 500,
      padding: "2px !important",
      margin: "0px !important",
    },
  });

  function Row(props) {
    const { list, i } = props;

    return (
      <React.Fragment>
        <Grid container className="invistegator-table-data" spacing={1}>
          <Grid item xs={2} className="overflow-hidden">
            <Label
              fontSize="14px"
              fontWeight="500"
              text={list?.drug_type}
              wordBreak="break-all"
              textTransform="none"
            />
          </Grid>

          <Grid item xs={2} className="overflow-hidden">
            <Label
              fontSize="14px"
              fontWeight="500"
              text={list?.project_name}
              wordBreak="break-all"
              textTransform="none"
            />
          </Grid>

          <Grid item xs={2} className="overflow-hidden">
            <Label
              fontSize="14px"
              fontWeight="500"
              text={list?.batch_name}
              wordBreak="break-all"
              textTransform="none"
            />
          </Grid>
          <Grid item xs={2} className="overflow-hidden">
            <Label
              fontSize="14px"
              fontWeight="500"
              text={list?.parameter_name}
              wordBreak="break-all"
              textTransform="none"
            />
          </Grid>
          <Grid item xs={2.5} className="overflow-hidden">
            <Label
              fontSize="14px"
              fontWeight="500"
              text={list?.parameter_value}
              wordBreak="break-all"
              textTransform="none"
            />
          </Grid>

          <Grid item xs={1} container>
            <Label
              fontSize="14px"
              fontWeight="500"
              text={list?.out_of_range ? "Yes" : "No"}
            />
          </Grid>

          <Grid
            item
            xs={0.5}
            container
            alignItems="center"
            justifyContent="center"
          >
            <CustomWidthTooltip
              title={
                <Box
                  p={2}
                  sx={{
                    backgroundColor: "#f5f5f9",
                    borderRadius: 1,
                    boxShadow: 2,
                    width: "400px",
                  }}
                >
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: "bold", mb: 1 }}
                  >
                    Other Details
                  </Typography>
                  <Divider sx={{ mb: 1 }} />
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "auto auto 1fr",
                      gap: 1,
                    }}
                  >
                    <Label text="Pdf Name " />
                    <Label text=":" />
                    <Label
                      text={list?.pdf_name}
                      textTransform="none"
                      wordBreak="break-word"
                      width="290px"
                    />
                    <Divider sx={{ gridColumn: "span 3", mb: 1 }} />

                    <Label text="Page No" />
                    <Label text=":" />
                    <Label
                      text={list?.page_no}
                      wordBreak="break-word"
                      width="290px"
                    />
                    <Divider sx={{ gridColumn: "span 3", mb: 1 }} />

                    <Label text="Pre Processor" />
                    <Label text=":" />
                    <Label
                      text={list?.pre_processor}
                      wordBreak="break-word"
                      width="290px"
                    />
                    <Divider sx={{ gridColumn: "span 3", mb: 1 }} />

                    <Label text="Processor" />
                    <Label text=":" />
                    <Label
                      text={list?.processor}
                      wordBreak="break-word"
                      width="290px"
                    />
                    <Divider sx={{ gridColumn: "span 3", mb: 1 }} />

                    <Label text="Validator" />
                    <Label text=":" />
                    <Label
                      text={list?.validator}
                      wordBreak="break-word"
                      width="290px"
                    />
                    <Divider sx={{ gridColumn: "span 3", mb: 1 }} />
                  </Box>
                </Box>
              }
              arrow
              placement="left"
            >
              <IconButton sx={{ mt: 1 }}>
                <InfoIcon />
              </IconButton>
            </CustomWidthTooltip>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }

  return (
    <div>
      <CAMSubHeader text={action.INVESTIGATION} />
      <div className="table-root">
        <InvestigationFilterNewForDBSearch
          export={onExportCLick}
          getFilteredData={getFilteredData}
          noTableData={tableData?.data.length === 0}
          // getReports={getReports}
        />

        <Box className="investigator-table-wrap">
          {investigationSearchApiStatus?.loader ? (
            <DashboardTableSkaleton />
          ) : tableData?.data?.length ? (
            <>
              <Grid container className="tableHeader" spacing={1}>
                <Grid item xs={2}>
                  <Label fontSize="14px" fontWeight="600" text={PRODUCT_NAME} />
                </Grid>

                <Grid item xs={2}>
                  <Label
                    fontSize="14px"
                    fontWeight="600"
                    text={TEMPLATE_NAME}
                  />
                </Grid>

                <Grid item xs={2}>
                  <Label fontSize="14px" fontWeight="600" text={BATCH_NAME} />
                </Grid>
                <Grid item xs={2}>
                  <Label
                    fontSize="14px"
                    fontWeight="600"
                    text={PARAMETER_NAME}
                  />
                </Grid>
                <Grid item xs={2.5}>
                  <Label fontSize="14px" fontWeight="600" text={VALUE} />
                </Grid>

                <Grid item xs={1}>
                  <Label fontSize="14px" fontWeight="600" text={OUT_OF_RANGE} />
                </Grid>
                <Grid item xs={0.5}></Grid>
              </Grid>

              <Grid>
                {tableData?.data?.map((list, i) => (
                  <Row
                    key={list?.pre_processor_id + i}
                    list={list}
                    i={i}
                    props={props}
                  />
                ))}
              </Grid>
            </>
          ) : (
            !investigationSearchApiStatus?.loader && (
              <div className="no-data">
                <Label
                  text="No Data Found"
                  fontSize="16"
                  fontWeight="600"
                  padding="20px"
                />
              </div>
            )
          )}
        </Box>

        <FileNameDialog
          openFileNamePopup={openFileNamePopup}
          onCLoseDialog={onCLoseDialog}
          exportData={exportData}
        />

        {err && (
          <CustomizedSnackbars
            severity="error"
            state={err}
            text={message}
            handleClose={() => setErr(false)}
          />
        )}

        {showUrlSnackbar && (
          <CustomizedSnackbars
            severity="success"
            state={showUrlSnackbar}
            text={message}
            handleClose={() => handleCloseurlSnackbar()}
            urlInside={false}
            // exportedUrl={exportedUrl}
          />
        )}

        <Grid className="pagination-wrap">
          <TablePagination
            component="div"
            rowsPerPageOptions={[100, 200, 300, 500]}
            count={parseInt(tableData?.total_count) || 0}
            page={parseInt(page)}
            onPageChange={handlePageChange}
            rowsPerPage={parseInt(rowsPerPage)}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Grid>
      </div>
    </div>
  );
};
export default InvestigationTable;
